const colourLookup = {
    'pink': '#fc1a7b',
    'purple': '#3b2d6e',
    'dev': '#0000ff',
    'ppc': '#ffff00',
    'seo': '#ff00ff',
    'design': '#ff0000',
    'podcast-pink': '#FC0767',
    'podcast-yellow': '#FFC400',
    'podcast-orange': '#FF5420',
    'podcast-red': '#DA2534',
    'white': '#ffffff',
};

const getColourHex = (colour) => {
    return colourLookup[colour];
}

export default getColourHex;